import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import BaseContactBox from './BaseContactBox';

const ContactBrochureBox = memo(({ value, boxText }) => {
  const { t } = useTranslation();
  const linkHref = value;

  return (
    <BaseContactBox
      {...{ boxText, linkHref }}
      classNames="contact-box--brochure"
      value={t('brochure_download')}
      download
    />
  );
});

ContactBrochureBox.displayName = 'ContactBrochureBox';

ContactBrochureBox.propTypes = {
  value: PropTypes.string.isRequired,
  boxText: PropTypes.string
};

export default ContactBrochureBox;
